import React from 'react';
import Old from './Old/Old';
import New from './New/New';
import { useCalendarContext } from './Provider';

const Main = ({calendarContainerRef, headerContainerRef, appointmentsContainerRef}) => {
    const {newCalendar} = useCalendarContext();

    if (newCalendar) {
        return <New {...{calendarContainerRef, headerContainerRef, appointmentsContainerRef}} />
    } else {
        return <Old {...{calendarContainerRef, headerContainerRef, appointmentsContainerRef}} />
    }
}

export default Main;